<template>
  <div class="contact-banner">
    <div class="contact-banner_container">
      <div class="contact-banner_icon">
        <oie-use-svg svg="phone" height="20" width="20"></oie-use-svg>
      </div>
      <div class="contact-banner__content">
        <p class="contact-banner__title">
          {{ t('questionsTitle') }}
        </p>
        <div class="contact-banner__text" v-html="t('questionsText')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

.contact-banner {
  background-color: color(blue-5);
  border-bottom: measure(quarter) solid color(blue-1);
  position: sticky;
  top: 0;
  z-index: 99;
}

.contact-banner_icon {
  position: relative;
  height: 20px;
  width: 20px;
}

.contact-banner_icon > svg {
  position: absolute;
  top: 5px;
  left: 0;
}

.contact-banner_container {
  @include container;
  padding-top: measure(quarter);
  padding-bottom: measure(quarter);
  display: flex;
}

.contact-banner_container > *:not(:last-child) {
  margin-right: measure(half);
}

.contact-banner__content p{
  margin: 0;
}

.contact-banner__title {
  @include body-bold;
}

.contact-banner__text {
  @include caption;
}

.contact-banner__text a{
  @include caption-bold;
  color: color(text);

  &:visited, &:active {
    color: initial;
  }
}

</style>
